<template>
  <div class="email">
    <Nav :msg="title"></Nav>
    <div class="send-email" v-if="!emailSucceed">
      <img class="icon-email" src="../assets/email.png">
      <h2 class="title">将电子合同通过邮件发送给用户</h2>
      <div class="input-group">
        <div class="pre-addon">
          <img class="input-icon-email" src="../assets/input-icon-email.png">
        </div>
        <input type="email" placeholder="输入邮箱" v-model="email">
      </div>
      <button @click="sendEmail">发送邮件</button>
    </div>
    <div class="email-success" v-else>
      <img class="icon-right" src="../assets/right.png">
      <h2 class="title">发送成功</h2>
      <p class="text">电子合同已经成功发送至用户邮箱</p>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import { userInfo, sendEmail } from '../api'

export default {
  name: 'enail',
  props: ['cid', 'token'],
  data () {
    return {
      title: '积木家电子签约平台',
      email: '',
      emailSucceed: false
    }
  },
  methods: {
    init () {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中'
      })
      userInfo({
        cid: this.cid,
        token: this.token
      })
        .then((result) => {
          toast.clear()
          // console.log(result.data.data.customer_info.customer_email)
          this.email = result.data.data.customer_info.customer_email
        }).catch((err) => {
          console.log(err)
        })
    },
    sendEmail () {
      const pattern = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
      if (!this.email.length) {
        this.$toast('请输入邮箱')
        return
      }
      if (!pattern.test(this.email)) {
        this.$toast('请输入正确的邮箱')
        return
      }
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中'
      })
      sendEmail({
        cid: this.cid,
        token: this.token,
        email: this.email
      })
        .then((result) => {
          toast.clear()
          if (result.data.status.succeed) {
            this.emailSucceed = true
          }
        }).catch((err) => {
          console.log(err)
        })
    }
  },
  components: {
    Nav
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.send-email {
  padding-top: 29.3333vw;
}
.email-success {
  padding-top: 37.8667vw;
}
.icon-right {
  width: 14.6667vw;
  display: block;
  margin: 0 auto;
}
.icon-email {
  width: 18vw;
  display: block;
  margin: 0 auto;
}
.input-group {
  border: 1px solid rgb(215, 215, 234);
  border-radius: 5.7333vw;
  width: 74.4vw;
  height: 11.2vw;
  margin: 0 auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: stretch;
  align-items: center;

  .pre-addon {
    width: 12vw;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 2.6667vw;
  }

  .input-icon-email {
    display: block;
    width: 4.6667vw;
  }

  input {
    font-size: 30px;
    color: rgb(0, 0, 0);
    appearance: none;
    border: 0;
    box-shadow: none;
    outline: none;
    flex-grow: 1;
    background-color: transparent;

    &::placeholder {
      color: rgb(203, 205, 226);
    }
  }
}
.title {
  text-align: center;
  color: rgb(36, 150, 249);
  font-size: 5.0667vw;
  line-height: 1em;
  margin: 9.3333vw 0 5.3333vw;
}

button {
  box-shadow: 0px 5px 16px 0px rgba(182, 214, 255, 1);
  background-color: rgb(255, 255, 255);
  width: 74.6667vw;
  height: 11.4667vw;
  border-radius: 40px;
  background-image: linear-gradient( 90deg, rgb(66,177,255) 0%, rgb(0,120,255) 100%);
  color: #fff;
  font-size: 30px;
  overflow: hidden;
  border: 0;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 9.3333vw auto 0;
}

.email-success {
  .title {
    margin: 3.2vw 0 2.6667vw;
  }

  .text {
    margin: 0;
    line-height: 1em;
    color: rgb(121, 124, 156);
    font-size: 3.7333vw;
  }
}
</style>
